import { mainApi } from '../../../../api/mainApi';
import { AccessState } from '../../../../types';
import { middlewareApi } from '../../../middleware/middlewareApi';
import { ExternalLink } from '../../../students/dashboard/interfaces/dashboard.interface';
import { CreateExternalLinks } from '../interfaces/externalLinks.interfaces';

export const externalLinksTags = middlewareApi.enhanceEndpoints({
  addTagTypes: ['ExternalLinks'],
});
// Define a service using a base URL and expected endpoints
export const externalLinksApi = externalLinksTags.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * @GET get one external link
     */
    getExternalLink: builder.query<ExternalLink, { profileId?: number; id: number }>({
      queryFn: async ({ profileId, id }, { getState }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };

          const user_profile_id = profileId || currentProfile?.profileId;

          const { data } = await mainApi.get<ExternalLink>(`/external-link-configurations/${id}`, {
            params: {
              user_profile_id,
              // data: 'all',
              // search,
            },
          });

          //   dispatch(setRolesList(data.data));

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: (result, error, { profileId }) => [{ type: 'ExternalLinks', id: 'LIST' }],
    }),
    /**
     * @POST create event
     */
    addExternalLink: builder.mutation<
      any,
      { profileId?: number; externalLinkPayload: Partial<CreateExternalLinks> }
    >({
      queryFn: async ({ profileId, externalLinkPayload }, { getState }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };
          const user_profile_id = profileId || currentProfile?.profileId;
          const { data } = await mainApi.post<any>('/external-link-configurations', {
            user_profile_id,
            ...externalLinkPayload,
          });

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: [{ type: 'ExternalLinks', id: 'LIST' }],
    }),

    /**
     * @PUT update event
     */
    updateExternalLink: builder.mutation<
      any,
      { profileId?: number; externalId: number; externalLinkPayload: Partial<CreateExternalLinks> }
    >({
      queryFn: async ({ profileId, externalId, externalLinkPayload }, { getState }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };
          const user_profile_id = profileId || currentProfile?.profileId;

          const { data } = await mainApi.put<any>(`/external-link-configurations/${externalId}`, {
            user_profile_id,
            ...externalLinkPayload,
          });

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: [{ type: 'ExternalLinks', id: 'LIST' }],
    }),

    /**
     * @DELETE remove event
     */
    deleteExternalLink: builder.mutation<any, { profileId?: number; externalId: number }>({
      queryFn: async ({ profileId, externalId }, { getState }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };
          const user_profile_id = profileId || currentProfile?.profileId;

          const { data } = await mainApi.delete(`/external-link-configurations/${externalId}`, {
            data: {
              user_profile_id,
            },
          });

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: [{ type: 'ExternalLinks', id: 'LIST' }],
    }),

    //
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useAddExternalLinkMutation,
  useDeleteExternalLinkMutation,
  useUpdateExternalLinkMutation,

  useGetExternalLinkQuery,
  useLazyGetExternalLinkQuery,
} = externalLinksApi;
